// Animated Progress Bar

// Home.jsx 

import React, { useRef, useEffect, useState } from 'react';
import { Canvas } from "@react-three/fiber";
import { Environment } from "@react-three/drei";
import { EffectComposer, HueSaturation } from "@react-three/postprocessing";
import { BlendFunction } from "postprocessing";
import ResponsiveCamera from "./ResponsiveCamera";
import { Landscape } from "./Landscape";
import { SphereEnv } from "./SphereEnv";
import { Airplane } from "./Airplane"; 
// import { Airplane, planePosition } from "./Airplane"; // add planePosition NEW
import { MotionBlur } from "./MotionBlur";
import './styles.css'; 
import './index.css'; 
import './App.css'; 
import telos from "./audio/telos.mp3";
import soundoff from "./images/soundoff.png";
import soundon from "./images/soundon.png";
import turbooff from "./images/turbooff.png";
import turboon from "./images/turboon.png";
import { toggleTurbo } from "./controls";  
// import { Targets } from "./Targets";
// import squadaLogoBanner from "./images/squadaLogoImage.png";
import squadaLogoBanner from "./images/squadaLogoBannerDCB.png";
import ProgressBar from './ProgressBar'; 
// import EnergyBeam from './EnergyBeam'; // NEW
import ParticlesComponent from './Particles';




const Home = () => {
  const audioRef = useRef();
  const [showLogoBanner, setShowLogoBanner] = useState(true);
  // const [sceneReady, setSceneReady] = useState(false); // NEW
  const [isPlayingMusic, setIsPlayingMusic] = useState(false);
  const [isTurboActive, setIsTurboActive] = useState(false);
  const [isMobilePortrait, setIsMobilePortrait] = useState(window.innerWidth <= 768 && window.innerHeight > window.innerWidth);

  

  const handleSceneReady = () => {
    // The scene is ready, hide the logo banner
    setShowLogoBanner(false);


    // Set opacity for audio and turbo buttons to 1 (fully visible)
    setButtonOpacity(1);
  };

  const [buttonOpacity, setButtonOpacity] = useState(0); // Initialize opacity to 0

  useEffect(() => {
    // Update button opacity based on whether the scene is ready
    setButtonOpacity(showLogoBanner ? 0 : 1);
  }, [showLogoBanner]);


  useEffect(() => {
    if (!audioRef.current) {
      audioRef.current = new Audio(telos);
      audioRef.current.volume = 0.09; // 0.4
      audioRef.current.loop = true;
    }

    if (isPlayingMusic) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }

    return () => {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    };
  }, [isPlayingMusic]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobilePortrait(window.innerWidth <= 768 && window.innerHeight > window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const handleAudioButtonClick = () => {
    setIsPlayingMusic((prevIsPlaying) => !prevIsPlaying);
  };


    // Turbo button click handler
    const handleTurboButtonClick = () => {
      toggleTurbo(); 
      setIsTurboActive((prevIsTurboActive) => !prevIsTurboActive);
  
      // Update the visual representation of the turbo button
      const turboButton = document.getElementById("turbo-button");
      if (turboButton) {
        turboButton.src = isTurboActive ? turboon : turbooff;
      }
    };

      // Prevent context menu on long-press
    const handleTurboButtonContextMenu = (e) => {
      e.preventDefault();
    };

    // Turbo button release handler 
    const handleTurboButtonRelease = () => {
      setIsTurboActive(false); 
    }; 

  return (
    <section className='w-full h-screen relative'>

      <Canvas onCreated={handleSceneReady} shadows>
      {/* <Canvas shadows> */}
        <SphereEnv />
        <Environment background={false} files={"assets/textures/envmap.hdr"} />

        <ResponsiveCamera />

        <Landscape />
        <ParticlesComponent />


        {/* Use the Airplane component with scale prop */}
        <Airplane scale={isMobilePortrait ? [0.008, 0.008, 0.008] : [0.01, 0.01, 0.01]} />
        
        {/* // EnergyBeam (A) */}
        {/* <EnergyBeam airplanePosition={planePosition} />  */}
        
        

        {/* <Targets /> */}

        <directionalLight
          castShadow
          color={"#f3d29a"}
          intensity={2}
          position={[10, 5, 4]}
          shadow-bias={-0.0005}
          shadow-mapSize-width={1024}
          shadow-mapSize-height={1024}
          shadow-camera-near={0.01}
          shadow-camera-far={20}
          shadow-camera-top={6}
          shadow-camera-bottom={-6}
          shadow-camera-left={-6.2}
          shadow-camera-right={6.4}
        />

        <EffectComposer>
          <MotionBlur />
          <HueSaturation
            blendFunction={BlendFunction.NORMAL}
            hue={-0.15}
            saturation={0.1}
          />
        </EffectComposer>
      </Canvas>


      {showLogoBanner && (
        <div className="logo-banner-container">
          <img src={squadaLogoBanner} alt="Squada Logo Banner" className="logo-banner" />
          <ProgressBar show={showLogoBanner} /> 
          {/* <ProgressBar show={!handleSceneReady} /> */}
        </div>
      )}



      <div className='fixed bottom-2 left-2' style={{ opacity: buttonOpacity }}>
        <img
          src={!isPlayingMusic ? soundoff : soundon}
          alt='jukebox'
          onTouchStart={handleAudioButtonClick}
          onClick={handleAudioButtonClick}
          className='w-10 h-10 cursor-pointer object-contain opacity-40'
        />
      </div>


      {/* <div id="turbo-button" className='turboButton'>  */}
      <div id="turbo-button" 
      style={{ userSelect: 'none', touchAction: 'none', opacity: buttonOpacity }}
      className='fixed bottom-2 right-2'
      onTouchMove={(e) => e.preventDefault()}>

        <img
          src={isTurboActive ? turboon : turbooff}
          alt='turbo'
          onTouchStart={handleTurboButtonClick}
          onTouchEnd={handleTurboButtonRelease}
          onClick={handleTurboButtonClick}
          onContextMenu={handleTurboButtonContextMenu}
          className='w-10 h-10 cursor-pointer object-contain opacity-40'
        />
      </div>
    </section>
  );
};

export default Home;


















// // Home.jsx 

// import React, { useRef, useEffect, useState } from 'react';
// import { Canvas } from "@react-three/fiber";
// import { Environment } from "@react-three/drei";
// import { EffectComposer, HueSaturation } from "@react-three/postprocessing";
// import { BlendFunction } from "postprocessing";
// import ResponsiveCamera from "./ResponsiveCamera";
// import { Landscape } from "./Landscape";
// import { SphereEnv } from "./SphereEnv";
// import { Airplane } from "./Airplane";
// import { MotionBlur } from "./MotionBlur";
// import './styles.css'; 
// import './index.css'; 
// import './App.css'; 
// import telos from "./audio/telos.mp3";
// import soundoff from "./images/soundoff.png";
// import soundon from "./images/soundon.png";
// import turbooff from "./images/turbooff.png";
// import turboon from "./images/turboon.png";
// import { toggleTurbo } from "./controls";  
// // import { Targets } from "./Targets";
// import squadaLogoBanner from "./images/squadaLogoImage.png";
// // import ProgressBar from './ProgressBar'; // NEW


// const Home = () => {
//   const audioRef = useRef();
//   const [showLogoBanner, setShowLogoBanner] = useState(true);
//   // const [sceneReady, setSceneReady] = useState(false); // NEW
//   const [isPlayingMusic, setIsPlayingMusic] = useState(false);
//   const [isTurboActive, setIsTurboActive] = useState(false);
//   const [isMobilePortrait, setIsMobilePortrait] = useState(window.innerWidth <= 768 && window.innerHeight > window.innerWidth);


//   // You can use this concept to add text intermittently during the flight

//   // useEffect(() => {
//   //   const logoBannerTimeout = setTimeout(() => {
//   //     setShowLogoBanner(false);
//   //   }, 5000); // 5000 milliseconds (5 seconds)

//   //   return () => clearTimeout(logoBannerTimeout);
//   // }, []);

//   // //NEW
//   // useEffect(() => {
//   //   // You can add logic here to determine when the scene is ready
//   //   // For now, let's assume the scene is ready after a fixed delay
//   //   const sceneReadyTimeout = setTimeout(() => {
//   //     setSceneReady(true);
//   //   }, 5000); // 5000 milliseconds (5 seconds)

//   //   return () => clearTimeout(sceneReadyTimeout);
//   // }, []);
  

//   const handleSceneReady = () => {
//     // The scene is ready, hide the logo banner
//     setShowLogoBanner(false);


//     // Set opacity for audio and turbo buttons to 1 (fully visible)
//     setButtonOpacity(1);
//   };

//   const [buttonOpacity, setButtonOpacity] = useState(0); // Initialize opacity to 0

//   useEffect(() => {
//     // Update button opacity based on whether the scene is ready
//     setButtonOpacity(showLogoBanner ? 0 : 1);
//   }, [showLogoBanner]);


//   useEffect(() => {
//     if (!audioRef.current) {
//       audioRef.current = new Audio(telos);
//       audioRef.current.volume = 0.09; // 0.4
//       audioRef.current.loop = true;
//     }

//     if (isPlayingMusic) {
//       audioRef.current.play();
//     } else {
//       audioRef.current.pause();
//     }

//     return () => {
//       audioRef.current.pause();
//       audioRef.current.currentTime = 0;
//     };
//   }, [isPlayingMusic]);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobilePortrait(window.innerWidth <= 768 && window.innerHeight > window.innerWidth);
//     };

//     window.addEventListener('resize', handleResize);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);


//   const handleAudioButtonClick = () => {
//     setIsPlayingMusic((prevIsPlaying) => !prevIsPlaying);
//   };


//     // Turbo button click handler
//     const handleTurboButtonClick = () => {
//       toggleTurbo(); 
//       setIsTurboActive((prevIsTurboActive) => !prevIsTurboActive);
  
//       // Update the visual representation of the turbo button
//       const turboButton = document.getElementById("turbo-button");
//       if (turboButton) {
//         turboButton.src = isTurboActive ? turboon : turbooff;
//       }
//     };

//       // Prevent context menu on long-press
//     const handleTurboButtonContextMenu = (e) => {
//       e.preventDefault();
//     };

//     // Turbo button release handler 
//     const handleTurboButtonRelease = () => {
//       setIsTurboActive(false); 
//     }; 

//   return (
//     <section className='w-full h-screen relative'>

//       <Canvas onCreated={handleSceneReady} shadows>
//       {/* <Canvas shadows> */}
//         <SphereEnv />
//         <Environment background={false} files={"assets/textures/envmap.hdr"} />

//         <ResponsiveCamera />

//         <Landscape />

//         {/* Use the Airplane component with scale prop */}
//         <Airplane scale={isMobilePortrait ? [0.008, 0.008, 0.008] : [0.01, 0.01, 0.01]} />
        
//         {/* <Targets /> */}

//         <directionalLight
//           castShadow
//           color={"#f3d29a"}
//           intensity={2}
//           position={[10, 5, 4]}
//           shadow-bias={-0.0005}
//           shadow-mapSize-width={1024}
//           shadow-mapSize-height={1024}
//           shadow-camera-near={0.01}
//           shadow-camera-far={20}
//           shadow-camera-top={6}
//           shadow-camera-bottom={-6}
//           shadow-camera-left={-6.2}
//           shadow-camera-right={6.4}
//         />

//         <EffectComposer>
//           <MotionBlur />
//           <HueSaturation
//             blendFunction={BlendFunction.NORMAL}
//             hue={-0.15}
//             saturation={0.1}
//           />
//         </EffectComposer>
//       </Canvas>


//       {showLogoBanner && (
//         <div className="logo-banner-container">
//           <img src={squadaLogoBanner} alt="Squada Logo Banner" className="logo-banner" />
//           {/* <ProgressBar show={!sceneReady} /> */}
//         </div>
//       )}



//       <div className='fixed bottom-2 left-2' style={{ opacity: buttonOpacity }}>
//         <img
//           src={!isPlayingMusic ? soundoff : soundon}
//           alt='jukebox'
//           onTouchStart={handleAudioButtonClick}
//           onClick={handleAudioButtonClick}
//           className='w-10 h-10 cursor-pointer object-contain opacity-40'
//         />
//       </div>


//       {/* <div id="turbo-button" className='turboButton'>  */}
//       <div id="turbo-button" 
//       style={{ userSelect: 'none', touchAction: 'none', opacity: buttonOpacity }}
//       className='fixed bottom-2 right-2'
//       onTouchMove={(e) => e.preventDefault()}>

//         <img
//           src={isTurboActive ? turboon : turbooff}
//           alt='turbo'
//           onTouchStart={handleTurboButtonClick}
//           onTouchEnd={handleTurboButtonRelease}
//           onClick={handleTurboButtonClick}
//           onContextMenu={handleTurboButtonContextMenu}
//           className='w-10 h-10 cursor-pointer object-contain opacity-40'
//         />
//       </div>
//     </section>
//   );
// };

// export default Home;